export default __webpack_public_path__ + "static/media/icon-started.2c28afcc.svg";